export default {
  TITLE: 'sectionTitle'
};
